import { gql } from '@lcs/shared/api';

export const getCallLogsQuery = gql`
   query GetCallLogs($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      callDetailsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            callDetailId
            account {
               accountId
               name
            }
            sourceExtension {
               extensionId
               number
               name
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callRecording {
               callRecordingId
               file {
                  fileId
                  fileToken
                  fileName
                  displayName
               }
            }
            callSegmentsConnection {
               items {
                  callSegmentId
                  callDetailId
                  sourceExtensionId
                  extensionId
                  sourceExtension {
                     extensionId
                     extensionType {
                        name
                     }
                     name
                     number
                  }
                  extension {
                     extensionId
                     extensionType {
                        name
                     }
                     name
                     number
                  }
                  startDate
                  endDate
                  sequence
                  duration
               }
            }
            callDispositionTypeName
            callDirectionTypeName
            destinationNumber
            callDispositionTypeId
            callDirectionTypeId
            startTime
            endTime
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            callerName
            callRate
            serverName
            sipCallId
            callRecordingCallDetailConnection {
               items {
                  callRecordingCallDetailId
                  callRecordingId
                  callDetailId
                  callRecording {
                     file {
                        fileId
                        fileToken
                        fileName
                        displayName
                     }
                  }
               }
            }
            queueHistoryCallDetailsConnection {
               items {
                  queueHistory {
                     queueHistoryId
                     callDetailId
                     queueExtensionId
                     enqueuedDateTime
                     callbackCompleteDateTime
                     callbackRequestDateTime
                     queueAgentDialsConnection {
                        items {
                           queueAgentDialId
                           queueHistoryId
                           agentExtension {
                              extensionId
                              name
                              number
                           }
                           dialStartTime
                           dialEndTime
                           dialStatus
                        }
                     }
                     queueCallbackDialsConnection {
                        items {
                           queueCallbackDialId
                           dialStartTime
                           dialEndTime
                        }
                     }
                     queueHistoryCallDetailsConnection {
                        items {
                           queueHistoryCallDetailId
                           callDetailId
                        }
                     }
                  }
               }
            }
            stirShakenAttest
            stirShakenToken
            stirShakenVerification
            destinationIpAddress
            providerId
            sourceProviderId
            destinationProviderId
            sourceIpAddress
         }
      }
   }
`;
